<template lang='pug'>
.articleStory
  GovAnnounceHead(:info="info" :staticData="staticData")
  GovAnnounceBody(:info="info" :staticData="staticData")
  GovAnnounceFoot(:info="info" :staticData="staticData" :followStatus="followStatus")
  </template>
<script>
import GovAnnounceHead from '@/components/modules/gov_announce_story/gov_announce_story_head.vue'
import GovAnnounceBody from '@/components/modules/gov_announce_story/gov_announce_story_body.vue'
import GovAnnounceFoot from '@/components/modules/gov_announce_story/gov_announce_story_foot.vue'
import StaticData from '@/assets/data.json'

export default {
  components: {
    GovAnnounceHead,
    GovAnnounceBody,
    GovAnnounceFoot,
    StaticData
  },
  props: {
    info: Object,
    staticData: Object,
    followStatus: Boolean
  }
}
</script>
